/// <reference path="../../vendor/typings/angularjs/angular.d.ts" />


angular.module('eseebase', ['lr.upload', 'angular.filter', 'ngMaterial', 'ngMessages', 'ngRoute', 'ngMap', 'angularMoment'])
    .config(['$mdThemingProvider', '$routeProvider', '$mdAriaProvider', '$compileProvider', '$mdDateLocaleProvider', 'moment',
        function ($mdThemingProvider, $routeProvider, $mdAriaProvider, $compileProvider, $mdDateLocaleProvider, moment) {
            $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|file|sms|tel|blob):/);
            $mdAriaProvider.disableWarnings();
            var textsResolver = {
                texts: ['$q', 'BaseService', 'TextService', function ($q, BaseService, TextService) {
                    return TextService.downloadTexts();
                }]
            };
            $mdDateLocaleProvider.formatDate = function (date) {
                var m = moment(date);
                return m.isValid() ? m.format('DD-MM-YYYY') : '';
            };
            $mdDateLocaleProvider.parseDate = function (dateString) {
                var m = moment(dateString, 'DD-MM-YYYY', true);
                return m.isValid() ? m.toDate() : new Date(NaN);
            };
            Date.prototype.toJSON = function ()
            {
                var m = moment(this);
                return m.isValid() ? moment(this).format() : '';
            }
            Date.prototype.toDateString = function () {
                var m = moment(this);
                return m.isValid() ? moment(this).format('DD-MM-YYYY') : '';
            }
            var companyResolver = {
                companyNumber: ['$q', 'CompanyService', 'CookiesService', function ($q, CompanyService, CookiesService) {
                    var d = $q.defer();
                    var companyNumber = CompanyService.getCurrentCompanyNumber();
                    if (companyNumber == null || companyNumber == '') {
                        return CompanyService.list().then((data: any[]) => {
                            if (data != null && data.length > 0) {
                                companyNumber = data[0].companyNumber;
                                CookiesService.createCookie('company', companyNumber, null);
                                d.resolve(companyNumber);
                            }
                            else {
                                d.reject(404);
                            }
                        }, (reason) => {
                            d.reject(reason);
                        });
                    }
                    else {
                        d.resolve(companyNumber);
                    }
                    return d.promise;
                }]
            };
            var configResolver = {
                cofiguration: ['$q', '$http', function ($q, $http) {
                    var d = $q.defer();
                    $http.get(`/appsettings.json`).then((data) => {
                        d.resolve(data.data);
                    }, () => {
                        return d.reject('Error reading configuration');
                    });
                    return d.promise;
                }]
            };
            var authResolver = {
                user: ['$q', 'UserService', '$rootScope', function ($q, UserService, $rootScope) {
                    var d = $q.defer();
                    UserService.getUser().then(function (data) {
                        $rootScope.$broadcast('$hideLoader');
                        if (data.roles.indexOf('Developer') == -1 || (data.type.indexOf('STD') == -1 && data.type.indexOf('DAB') == -1)) {
                            return d.reject({ authenticated: false, accessDenied: true });
                        }
                        else if (data && data.email != '') {
                            return d.resolve(data);
                        } else {
                            return d.reject({ authenticated: false });
                        }
                    }, function () {
                        $rootScope.$broadcast('$hideLoader');
                        return d.reject({ authenticated: false });
                    });
                    return d.promise;
                }],
                texts: textsResolver.texts,
                companyNumber: companyResolver.companyNumber,
                configuration: configResolver.cofiguration
            };

            $routeProvider
                .when("/overview", { 
                    title: 'PageTitle_Models',
                    templateUrl: "/app/model-list.html",
                    controller: 'FileController',
                    controllerAs: 'vm',
                    resolve: authResolver
                })
                .when("/login", {
                    title: 'PageTitle_Login',
                    templateUrl: "/app/login.html",
                    controller: 'LoginController',
                    controllerAs: 'vm',
                    resolve: textsResolver
                })
                .when("/profile", {
                    title: 'PageTitle_Profile',
                    templateUrl: "/app/user-profile.html",
                    controller: 'ProfileController',
                    controllerAs: 'vm',
                    resolve: authResolver
                })
                .when("/map", {
                    title: 'PageTitle_Map',
                    templateUrl: "/app/map/map.html",
                    controller: 'MapController',
                    controllerAs: 'vm',
                    resolve: authResolver
                })
                .when("/building/floorplan/:companyNumber/:correctionId", {
                    title: 'PageTitle_BuildingData',
                    templateUrl: "/app/building/building-data.html",
                    controller: 'BuildingDataController',
                    controllerAs: 'vm',
                    resolve: authResolver
                })
                .when("/building/:tab", {
                    title: 'PageTitle_BuildingData',
                    templateUrl: "/app/building/building-data.html",
                    controller: 'BuildingDataController',
                    controllerAs: 'vm',
                    resolve: authResolver
                })
                .when("/building", {
                    redirectTo: '/building/floorplan'
                })
                .when("/tutorial", {
                    title: 'PageTitle_Tutorial',
                    templateUrl: "/app/tutorial/tutorial.html",
                    controller: 'TutorialController',
                    controllerAs: 'vm',
                    resolve: authResolver
                })
                .when("/reports", {
                    title: 'PageTitle_MyReports',
                    templateUrl: "/app/floorplan/my-reports.html",
                    controller: 'MyReportController',
                    controllerAs: 'vm',
                    resolve: authResolver
                })
                .when("/statistics", {
                    title: 'PageTitle_Statistics',
                    templateUrl: "/app/map/map.html",
                    controller: 'MapController',
                    controllerAs: 'vm',
                    resolve: authResolver
                })
                .when("/forge", {
                    title: 'PageTitle_ForgeJobs',
                    templateUrl: "/app/forge/jobs.html",
                    controller: 'ForgeJobController',
                    controllerAs: 'vm',
                    resolve: authResolver
                })
                .when("/viewer3d/:objectId", {
                    title: 'PageTitle_Viewer3d',
                    templateUrl: "/app/forge/viewer3d.html",
                    controller: 'Viewer3dController',
                    controllerAs: 'vm',
                    resolve: authResolver
                })        
                .when("/newpassword/:token", {
                    title: 'PageTitle_PasswordReset',
                    templateUrl: "/app/reset-password.html",
                    controller: 'PasswordResetController',
                    controllerAs: 'vm',
                    resolve: textsResolver
                })    
                .otherwise({
                    redirectTo: '/map'
                });

            $mdThemingProvider.definePalette('eseebasePalette', {
                '50': 'c1c7b8',
                '100': 'a2ac91',
                '200': '858f73',
                '300': '747e64',
                '400': '4c5241',
                '500': '4c5241',
                '600': '4c5241',
                '700': '4c5241',
                '800': '4c5241',
                '900': '4c5241',
                'A100': '4c5241',
                'A200': '4c5241',
                'A400': '4c5241',
                'A700': '4c5241',
                'contrastDefaultColor': 'light',    // whether, by default, text (contrast)
                // on this palette should be dark or light

                'contrastDarkColors': [],
                'contrastLightColors': ['50', '100', '200', '300', 'A100']    // could also specify this if default was 'dark'
            });

            $mdThemingProvider.theme('default')
                .primaryPalette('eseebasePalette')
                .accentPalette('eseebasePalette')
            }
    ]).run(['$rootScope', '$window', '$timeout', 'AnalyticsService', function ($rootScope, $window, $timeout, AnalyticsService) {
        AnalyticsService.registerEvents();
        $rootScope.$on("$routeChangeError", function (event, current, previous, eventObj) {
            if (eventObj.authenticated === false) {
                if (eventObj.accessDenied === true) {
                    window.location.href = '/#!/login?accessDenied=true&redirectUrl=' + encodeURIComponent(window.location.pathname);
                }
                else {
                    $window.location.href = '/#!/login?redirectUrl=' + encodeURIComponent($window.location.pathname);
                }
            }
        });
    }]);